import { ProductVideo } from 'src/admin-entity/interface/product/product-video.interface';

export interface ProductVideoSliceType {
    searchCondition: {
        searchVideoName: string;
        searchProductName: string;
        searchDistributor: string;
        searchCategory: { id: number; name: string };
        searchProductStatus: string;
    };
    searchResult: {
        list: ProductVideo[];
        page: {
            count: number;
        };
    };
    page: number;
    take: number;

    searchConditionForModal: {
        searchVideoName: string;
        searchProductName: string;
        searchDistributor: string;
        searchCategory: { id: number; name: string };
        searchProductStatus: string;
    };
    searchResultForModal: {
        list: ProductVideo[];
        page: {
            count: number;
        };
    };
    pageForModal: number;
    takeForModal: number;
    selectedProductVideos: ProductVideo[];
}

export const ProductVideoSliceInitState: ProductVideoSliceType = {
    searchCondition: {
        searchVideoName: '',
        searchProductName: '',
        searchDistributor: '',
        searchCategory: {
            id: 0,
            name: '',
        },
        searchProductStatus: 'all-status',
    },
    searchResult: {
        list: [],
        page: {
            count: 0,
        },
    },
    page: 0,
    take: 30,
    searchConditionForModal: {
        searchVideoName: '',
        searchProductName: '',
        searchDistributor: '',
        searchCategory: {
            id: 0,
            name: '',
        },
        searchProductStatus: 'all-status',
    },
    searchResultForModal: {
        list: [],
        page: {
            count: 0,
        },
    },
    pageForModal: 0,
    takeForModal: 30,
    selectedProductVideos: [],
};
